<template>
  <label
  v-if="label"
  :for="id" :class="['block text-sm font-semibold mb-1 cursor-pointer dark:text-white',!isError ? 'text-gray-800':'text-red-500']" >{{ label }} <span class="text-red-500">{{ required ? '*':'' }}</span></label>
  <input
    :id="id"  type="checkbox" v-bind="$attrs"
    :class="`form-checkbox relative bg-gray-100 border-transparent text-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 disabled:opacity-50 disabled:pointer-events-none checked:bg-none dark:bg-neutral-800 dark:border-neutral-700 dark:focus:ring-offset-gray-600 before:inline-block before:bg-white before:rounded-full before:shadow before:transform before:ring-0 before:transition before:ease-in-out before:duration-200 dark:before:bg-neutral-400 ${sizes[size]} ${thumbSizes[size]} ${colors[color]}`"
    :checked="model === trueValue"
    @change="changeValue"
     v-on="eventHandlers">
  <template v-if="icon">
    <span
      class="peer-checked:text-blue-600  text-gray-500 size-5 absolute top-[3px] start-0.5 flex justify-center items-center pointer-events-none transition-colors ease-in-out duration-200">
      <svg
        class="shrink-0 size-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
      </svg>
    </span>
    <span
      class="peer-checked:text-white size-5 absolute top-[3px] end-0.5 flex justify-center items-center pointer-events-none transition-colors ease-in-out duration-200">
      <svg
        class="shrink-0 size-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </span>
  </template>
  <ErrorTag :is-error="isError" :error-message="errorMessage"  />
</template>
<script setup lang="ts">
import type { IConfCompxfuncion } from '@/modules/Administracion/interfaces';
import { getEventHandlers, getIsError, generarUuid } from '@/modules/Core/usings/generales';
import { computed } from 'vue'
const model = defineModel<string | boolean | number | null>()
const props = defineProps<{
  id?: string
  label?: string
  color?: string
  size?: string
  trueValue?: string | number | boolean | null
  falseValue?: string | number | boolean | null
  icon?: string
  error?: string | Array<string> | null | undefined
  required?: boolean
  compxfunciones?: IConfCompxfuncion[]
}>()

const errorMessage = computed(()=> props.error)

const eventHandlers = computed(() => {
  let handlers: Record<string, (e: Event) => void> = {}
  if (props.compxfunciones && props.compxfunciones.length > 0) {
    handlers = getEventHandlers(typeof(props.compxfunciones) === 'string' ? JSON.parse(props.compxfunciones): props.compxfunciones)
  }
  return handlers
})
const isError = computed(() => {
  const isArray = Array.isArray(props.error)
  return getIsError(props, isArray)
})
const {
  id= generarUuid(),
  color='default',
  size='default',
  trueValue= true,
  falseValue= false,
  required = false
 } = props

const thumbSizes = {
  extrasmall: ' before:w-[15px] before:h-[15px] checked:before:translate-x-[14px] ',
  small: ' before:w-5 before:h-5 checked:before:translate-x-5 ',
  default: ' before:w-6 before:h-6 checked:before:translate-x-6 ',
  large: ' before:w-7 before:h-7 checked:before:translate-x-7 ',
} as Record<string, string>
const sizes = {
  extrasmall: ' w-[35px] h-[21px] ',
  small: ' w-11 h-6 p-px ',
  default: ' w-[3.25rem] h-7 p-px ',
  large: ' w-[4.25rem] h-9 p-px ',
} as Record<string, string>
const colors = {
  default: ' checked:before:bg-blue-200 dark:checked:bg-blue-500 dark:checked:border-blue-500 checked:text-blue-600 checked:border-blue-600 focus:checked:border-blue-600 dark:checked:before:bg-blue-200 focus:ring-blue-600 ',
  red: ' checked:before:bg-red-200 dark:checked:bg-red-500 dark:checked:border-red-500 checked:text-red-600 checked:border-red-600 focus:checked:border-red-600 dark:checked:before:bg-red-200 focus:ring-red-600 ',
  blue: ' checked:before:bg-blue-200 dark:checked:bg-blue-500 dark:checked:border-blue-500 checked:text-blue-600 checked:border-blue-600 focus:checked:border-blue-600 dark:checked:before:bg-blue-200 focus:ring-blue-600 ',
  green: ' checked:before:bg-green-200 dark:checked:bg-green-500 dark:checked:border-green-500 checked:text-green-600 checked:border-green-600 focus:checked:border-green-600 dark:checked:before:bg-green-200 focus:ring-green-600 ',
  yellow: ' checked:before:bg-yellow-200 dark:checked:bg-yellow-500 dark:checked:border-yellow-500 checked:text-yellow-600 checked:border-yellow-600 focus:checked:border-yellow-600 dark:checked:before:bg-yellow-200 focus:ring-yellow-600 ',
} as Record<string, string>

const changeValue = (e: Event) => {
  if (!e.target) {
    console.warn('Event target is null')
    return
  }
  model.value = (e.target as HTMLInputElement).checked ? trueValue : falseValue
}
</script>
